/* Deckaura free-cards-only (2026-10-26)
 * Free tool results show the drawn cards with keywords + a one-line general meaning.
 * Question-specific interpretation is hidden (CSS in sections/dk-free-cards-only.liquid)
 * and replaced by a lock box that points to the paid readings.
 * Config: window.DkFreeCardsCfg (written by the section per template). */
(function () {
  'use strict';
  if (window.__dkFreeCardsOnly) return;
  window.__dkFreeCardsOnly = true;

  var CFG = window.DkFreeCardsCfg;
  if (!CFG) return;
  var LANG = CFG.lang || 'en';

  var STR = {
    en: {
      eyebrow: 'Free card keys', title: 'Keywords and core meaning', up: 'Upright', rev: 'Reversed',
      lockTitle: 'Your full interpretation is locked',
      lockCards: 'How these cards answer your exact question is written in your personal reading.',
      lockCard: 'How this card answers your exact question is written in your personal reading.',
      lockResult: 'How this result answers your exact question is written in your personal reading.',
      bulletsCards: ['How the cards answer your question', 'What links them together', 'One clear next step'],
      bulletsCard: ['What the card says about your question', 'What could change the answer', 'One clear next step'],
      bulletsResult: ['What it means for your question', 'What is changing and why', 'One clear next step'],
      cta: 'See reading options'
    },
    tr: {
      eyebrow: 'Ücretsiz kart anahtarları', title: 'Anahtar kelimeler ve temel anlam', up: 'Düz', rev: 'Ters',
      lockTitle: 'Tam yorumun kilitli',
      lockCards: 'Bu kartların sorduğun soruya nasıl cevap verdiği kişisel okumanda yazılır.',
      lockCard: 'Bu kartın sorduğun soruya nasıl cevap verdiği kişisel okumanda yazılır.',
      lockResult: 'Bu sonucun sorduğun soruya nasıl cevap verdiği kişisel okumanda yazılır.',
      bulletsCards: ['Kartların soruna cevabı', 'Kartlar arasındaki bağ', 'Net bir sonraki adım'],
      bulletsCard: ['Kartın soruna cevabı', 'Cevabı neyin değiştirebileceği', 'Net bir sonraki adım'],
      bulletsResult: ['Sorun için ne anlama geldiği', 'Neyin neden değiştiği', 'Net bir sonraki adım'],
      cta: 'Okuma seçeneklerini gör'
    },
    es: {
      eyebrow: 'Claves gratuitas de tus cartas', title: 'Palabras clave y significado esencial', up: 'Al derecho', rev: 'Invertida',
      lockTitle: 'Tu interpretación completa está bloqueada',
      lockCards: 'Cómo responden estas cartas a tu pregunta exacta se escribe en tu lectura personal.',
      lockCard: 'Cómo responde esta carta a tu pregunta exacta se escribe en tu lectura personal.',
      lockResult: 'Cómo responde este resultado a tu pregunta exacta se escribe en tu lectura personal.',
      bulletsCards: ['Qué responden las cartas a tu pregunta', 'Qué las une entre sí', 'Un siguiente paso claro'],
      bulletsCard: ['Qué dice la carta sobre tu pregunta', 'Qué podría cambiar la respuesta', 'Un siguiente paso claro'],
      bulletsResult: ['Qué significa para tu pregunta', 'Qué está cambiando y por qué', 'Un siguiente paso claro'],
      cta: 'Ver opciones de lectura'
    },
    de: {
      eyebrow: 'Kostenlose Kartenschlüssel', title: 'Schlüsselwörter und Kernbedeutung', up: 'Aufrecht', rev: 'Umgekehrt',
      lockTitle: 'Deine vollständige Deutung ist gesperrt',
      lockCards: 'Wie diese Karten deine genaue Frage beantworten, steht in deiner persönlichen Deutung.',
      lockCard: 'Wie diese Karte deine genaue Frage beantwortet, steht in deiner persönlichen Deutung.',
      lockResult: 'Wie dieses Ergebnis deine genaue Frage beantwortet, steht in deiner persönlichen Deutung.',
      bulletsCards: ['Was die Karten zu deiner Frage sagen', 'Wie sie zusammenhängen', 'Ein klarer nächster Schritt'],
      bulletsCard: ['Was die Karte zu deiner Frage sagt', 'Was die Antwort ändern könnte', 'Ein klarer nächster Schritt'],
      bulletsResult: ['Was es für deine Frage bedeutet', 'Was sich verändert und warum', 'Ein klarer nächster Schritt'],
      cta: 'Deutungsoptionen ansehen'
    },
    pt: {
      eyebrow: 'Chaves gratuitas das suas cartas', title: 'Palavras-chave e significado essencial', up: 'Normal', rev: 'Invertida',
      lockTitle: 'Sua interpretação completa está bloqueada',
      lockCards: 'Como estas cartas respondem à sua pergunta exata é escrito na sua leitura pessoal.',
      lockCard: 'Como esta carta responde à sua pergunta exata é escrito na sua leitura pessoal.',
      lockResult: 'Como este resultado responde à sua pergunta exata é escrito na sua leitura pessoal.',
      bulletsCards: ['O que as cartas dizem sobre sua pergunta', 'O que as liga entre si', 'Um próximo passo claro'],
      bulletsCard: ['O que a carta diz sobre sua pergunta', 'O que poderia mudar a resposta', 'Um próximo passo claro'],
      bulletsResult: ['O que significa para sua pergunta', 'O que está mudando e por quê', 'Um próximo passo claro'],
      cta: 'Ver opções de leitura'
    }
  };
  var S = STR[LANG] || STR.en;

  var IMG_SEL = 'img[src*=dkc-],img[srcset*=dkc-],img[data-src*=dkc-]';
  var WS = new RegExp('[' + String.fromCharCode(9, 10, 11, 12, 13, 32, 160) + ']+', 'g');
  var REV_RE = /(^|[^a-zÀ-ɏ])(reversed|invertid[ao]|umgekehrt|ters|al rev[eé]s)([^a-zÀ-ɏ]|$)/i;
  var LOCK_SVG = `<svg viewBox='0 0 24 24' width='15' height='15' aria-hidden='true' focusable='false'><path fill='currentColor' d='M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5Zm-3 8V7a3 3 0 1 1 6 0v3H9Z'/></svg>`;

  function all(sel, root) {
    if (!sel) return [];
    try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; }
  }
  function one(sel, root) { return all(sel, root)[0] || null; }
  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (cs.display === 'contents') {
      for (var c = el.firstElementChild; c; c = c.nextElementSibling) if (isVisible(c)) return true;
      return false;
    }
    return el.getClientRects().length > 0;
  }
  function firstVisible(sel, root) {
    var list = all(sel, root);
    for (var i = 0; i < list.length; i++) if (isVisible(list[i])) return list[i];
    return null;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function track(name) {
    try { if (typeof window.clarity === 'function') window.clarity('event', name + '_' + (CFG.tool || 'tool')); } catch (e) {}
  }

  /* ---------- card data ---------- */
  var KEYS = null, NAME_INDEX = null;
  function keys() {
    if (!KEYS) { var d = window.DeckauraFreeKeys || {}; KEYS = d[LANG] || d.en || null; }
    return KEYS;
  }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/ı/g, 'i').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function nameIndex() {
    if (NAME_INDEX) return NAME_INDEX;
    var K = keys() || {};
    NAME_INDEX = [];
    Object.keys(K).forEach(function (slug) {
      var local = norm(K[slug][0]);
      if (local.length >= 3) NAME_INDEX.push([local, slug]);
      NAME_INDEX.push([slug.replace(/-/g, ' '), slug]);
    });
    NAME_INDEX.sort(function (a, b) { return b[0].length - a[0].length; });
    return NAME_INDEX;
  }
  function slugFromText(text) {
    var t = ' ' + norm(text) + ' ';
    var idx = nameIndex();
    for (var i = 0; i < idx.length; i++) if (t.indexOf(' ' + idx[i][0] + ' ') >= 0) return idx[i][1];
    return null;
  }
  function slugFromImg(img) {
    var K = keys();
    if (!K || !img) return null;
    var src = [img.currentSrc, img.getAttribute('src'), img.getAttribute('data-src'), img.getAttribute('srcset')].join(' ');
    var m = src.match(/dkc-([a-z0-9-]+)/i);
    if (!m) return null;
    var s = m[1].toLowerCase();
    while (s && !K[s]) {
      var i = s.lastIndexOf('-');
      if (i < 0) return null;
      s = s.slice(0, i);
    }
    return s || null;
  }
  function rot180(node) {
    if (!node || node.nodeType !== 1) return false;
    var cs = getComputedStyle(node);
    if (cs.rotate && cs.rotate !== 'none') {
      var deg = parseFloat(cs.rotate);
      if (Math.abs(Math.abs(deg) - 180) < 20) return true;
    }
    var t = cs.transform;
    if (!t || t === 'none') return false;
    var m = t.match(/matrix(3d)?[(]([^)]+)[)]/);
    if (!m) return false;
    var p = m[2].split(',').map(parseFloat);
    var a = p[0], d = m[1] ? p[5] : p[3];
    return a < -0.7 && d < -0.7;
  }
  function isReversed(img, item, label) {
    if (img) {
      var x = img;
      for (var i = 0; i < 3 && x && x !== item.parentElement; i++) {
        if (rot180(x)) return true;
        x = x.parentElement;
      }
    }
    var txt = String(item.innerText || item.textContent || '') + ' ' + (item.getAttribute('aria-label') || '');
    if (label) txt = txt.replace(label, ' ');
    return REV_RE.test(txt);
  }
  function clean(s) { return String(s || '').replace(WS, ' ').trim(); }
  function itemLabel(item, spec) {
    if (spec.label) { var l = one(spec.label, item); return l ? clean(l.textContent) : ''; }
    if (spec.labelAttr) {
      var v = item.getAttribute(spec.labelAttr) || '';
      var m = spec.labelRe ? v.match(new RegExp(spec.labelRe)) : null;
      return m ? clean(m[1]) : '';
    }
    return '';
  }
  function cardImg(item) {
    var imgs = item.matches && item.matches(IMG_SEL) ? [item] : all(IMG_SEL, item);
    for (var i = 0; i < imgs.length; i++) if (slugFromImg(imgs[i])) return imgs[i];
    return null;
  }
  function collectCards(scope, spec) {
    if (!keys()) return [];
    var items = spec.item ? all(spec.item, scope) : all(IMG_SEL, scope).map(function (img) { return img.parentElement; });
    var out = [], seen = {}, n = 0;
    var labelList = spec.labels ? all(spec.labels).map(function (l) { return clean(l.textContent); }).filter(Boolean) : null;
    items.forEach(function (item) {
      if (!item || (!spec.hidden && !isVisible(item))) return;
      var img = cardImg(item);
      var label = itemLabel(item, spec) || (labelList ? labelList[n] || '' : '');
      n++;
      var slug = slugFromImg(img);
      if (!slug) {
        var txt = String(item.innerText || item.textContent || '');
        slug = slugFromText(label ? txt.replace(label, ' ') : txt);
      }
      if (!slug) return;
      var key = slug + '|' + label;
      if (seen[key]) return;
      seen[key] = 1;
      out.push({ slug: slug, rev: isReversed(img, item, label), label: label });
    });
    return out;
  }

  /* ---------- panel ---------- */
  function onCta(ev) {
    if (ev) ev.preventDefault();
    track('dkfc_cta');
    if (CFG.ctaClick) {
      var c = firstVisible(CFG.ctaClick);
      if (c) { c.click(); return; }
    }
    var target = firstVisible(CFG.packages) || one(CFG.packages);
    if (target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }
  function lockLine(cls, text) {
    var p = el(cls === 'li' ? 'li' : 'p', cls === 'li' ? '' : cls);
    p.innerHTML = LOCK_SVG;
    p.appendChild(document.createTextNode(' ' + text));
    return p;
  }
  function buildPanel(cards) {
    var K = keys();
    var root = el('section', 'dkfc' + (CFG.theme ? ' dkfc--' + CFG.theme : ''));
    root.setAttribute('data-deckaura-no-i18n', '');
    root.setAttribute('data-dkfc', CFG.tool || '');
    var hasCards = CFG.mode !== 'lock' && K && cards.length;
    if (hasCards) {
      root.appendChild(el('p', 'dkfc__eyebrow', S.eyebrow));
      root.appendChild(el('h3', 'dkfc__title', S.title));
      var list = el('ol', 'dkfc__list');
      cards.forEach(function (c) {
        var e = K[c.slug];
        if (!e) return;
        var parts = String(c.rev ? e[2] : e[1]).split('|');
        var li = el('li', 'dkfc__item');
        var head = el('div', 'dkfc__head');
        if (c.label) head.appendChild(el('span', 'dkfc__pos', c.label));
        head.appendChild(el('strong', 'dkfc__name', e[0]));
        if (CFG.orientation !== false) head.appendChild(el('span', 'dkfc__orient' + (c.rev ? ' is-rev' : ''), c.rev ? S.rev : S.up));
        li.appendChild(head);
        var kw = el('div', 'dkfc__keys');
        parts[0].split(',').forEach(function (k) { k = k.trim(); if (k) kw.appendChild(el('span', 'dkfc__key', k)); });
        li.appendChild(kw);
        if (parts[1]) li.appendChild(el('p', 'dkfc__meaning', parts[1]));
        list.appendChild(li);
      });
      root.appendChild(list);
    }
    var lock = el('div', 'dkfc__lock');
    lock.appendChild(lockLine('dkfc__lock-title', S.lockTitle));
    var single = hasCards && cards.length === 1;
    lock.appendChild(el('p', 'dkfc__lock-text', hasCards ? (single ? S.lockCard : S.lockCards) : S.lockResult));
    var ul = el('ul', 'dkfc__lock-list');
    (hasCards ? (single ? S.bulletsCard : S.bulletsCards) : S.bulletsResult).forEach(function (b) { ul.appendChild(lockLine('li', b)); });
    lock.appendChild(ul);
    if (CFG.packages || CFG.ctaClick) {
      var btn = el('button', 'dkfc__cta', S.cta + ' ↓');
      btn.type = 'button';
      btn.addEventListener('click', onCta);
      lock.appendChild(btn);
    }
    root.appendChild(lock);
    return root;
  }

  /* ---------- copy fixes (false free promises) ---------- */
  function applyCopy() {
    (CFG.copy || []).forEach(function (rule) {
      all(rule.sel).forEach(function (node) {
        if (rule.hide) {
          if (node.style.getPropertyValue('display') !== 'none') node.style.setProperty('display', 'none', 'important');
          return;
        }
        var txt = rule.text && (rule.text[LANG] || rule.text.en);
        if (!txt) return;
        if (node.textContent !== txt) {
          node.textContent = txt;
          node.setAttribute('data-deckaura-no-i18n', '');
        }
      });
    });
  }

  /* ---------- placement loop ---------- */
  var panel = null, sig = '', scheduled = false, shown = false;
  function placed(p, a) {
    switch (CFG.where) {
      case 'before': return a.previousElementSibling === p;
      case 'after': return a.nextElementSibling === p;
      case 'prepend': return a.firstElementChild === p;
      default: return a.lastElementChild === p;
    }
  }
  function insert(p, a) {
    switch (CFG.where) {
      case 'before': a.parentNode.insertBefore(p, a); break;
      case 'after': a.parentNode.insertBefore(p, a.nextSibling); break;
      case 'prepend': a.insertBefore(p, a.firstChild); break;
      default: a.appendChild(p);
    }
  }
  function removePanel() {
    if (panel && panel.parentNode) panel.parentNode.removeChild(panel);
    panel = null;
    sig = '';
  }
  function tick() {
    scheduled = false;
    applyCopy();
    var ready = firstVisible(CFG.ready);
    if (!ready) { removePanel(); return; }
    var anchor = one(CFG.anchor, ready) || one(CFG.anchor);
    if (!anchor || !anchor.parentNode) return;
    var scope = CFG.scope ? (firstVisible(CFG.scope) || one(CFG.scope) || document) : document;
    var cards = CFG.mode === 'lock' ? [] : collectCards(scope, CFG);
    if (!cards.length && CFG.mode !== 'lock' && CFG.fallback) cards = collectCards(scope, CFG.fallback);
    var next = LANG + '#' + cards.map(function (c) { return c.slug + (c.rev ? 'R' : 'U') + c.label; }).join(',');
    if (panel && panel.isConnected && placed(panel, anchor) && next === sig) return;
    removePanel();
    panel = buildPanel(cards);
    sig = next;
    insert(panel, anchor);
    if (!shown) { shown = true; track('dkfc_shown'); }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(tick, 120);
  }
  function start() {
    var root = document.querySelector(CFG.root || 'main') || document.body;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (panel && (t === panel || panel.contains(t))) continue;
        schedule();
        return;
      }
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'src', 'aria-hidden'] });
    document.addEventListener('click', function () { setTimeout(schedule, 450); setTimeout(schedule, 1600); }, true);
    window.addEventListener('pageshow', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
